<mat-card *ngIf="!loading" class="mcd-card">
  <mat-card-header class="mcd-card-header">
    <mat-card-title class="mcd-card-title"
      >View As Different Role</mat-card-title
    >
  </mat-card-header>
  <div class="mat-card-wrapper">
    <mat-card-content class="mcd-card-content">
      <div class="mcd-edit-form mcd-grbes-form  ">
        <div class="row">
          <div class="col-3"></div>
          <div class="col-6">
            <div class="list-group">
              <button
                class="list-group-item list-group-item-action"
                [ngClass]="{ 'selected-button': selectedRole === 'AOW Admin' }"
                (click)="selectRole('AOW Admin')"
              >
                Segment Lead
              </button>
              <button
                class="list-group-item list-group-item-action"
                [ngClass]="{ 'selected-button': selectedRole === 'Market Admin' }"
                (click)="selectRole('Market Admin')"
              >
                Market Admin
              </button>
              <button
                class="list-group-item list-group-item-action"
                [ngClass]="{ 'selected-button': selectedRole === 'Basic User' }"
                (click)="selectRole('Basic User')"
              >
                Basic User
              </button>

            </div>
           <mat-form-field style="margin-top: 30px" *ngIf="selectedRole == 'Market Admin' || selectedRole == 'AOW Admin' || selectedRole == 'Basic User'">
            <mat-label>Country</mat-label>
            <mat-select
              name="dropCategory"
              [(ngModel)]="selectedCountryId"
              #country
              (selectionChange)="selectCountry($event)"
              required
            >
              <mat-option
                *ngFor="let item of countries ; let j = index "
                [value]="item.id"
                >{{ item.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="selectedRole == 'AOW Admin'">
            <mat-label>AOWGroup</mat-label>
            <mat-select
              name="dropLocation"
              #aowGroup
              (selectionChange)="selectAOW($event)"
              required
            >
              <mat-option
                [value]="item.id"
                *ngFor="let item of aowGroups"
              >
                {{ item.groupName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="list-group" style="align-items: center; margin-top: 20px;" *ngIf="selectedRole != ''">
            <button
              class="list-group-view list-group-item-action"
              (click)="viewAsRole()"
            >
             View
            </button>
          </div>
          </div>
         
          
       
          <div class="col-3"></div>
        </div>
      </div>
    </mat-card-content>
    <mat-card-footer class="mcd-card-footer"> </mat-card-footer>
  </div>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>
